import { db } from '../firebase';
import { dispatch } from '../../store'
import {LISTEN_ADMIN_EVENTS, FETCH_EVENTS} from '../../constants/actionTypes'
import {doFetchUser} from './handleUsers'
import { doDeleteMessage } from './handleMessaging'
import moment from 'moment'
//import adminCanidateReducer from '../../reducers/adminCanidate';
import _ from 'lodash'
const eventsRef = db.ref('/events')
const refConnectedEvent = db.ref('/connectedEvents')
const refConfirmedEvent = db.ref('/confirmedEvent')
//const myConfirmedEventsRef = db.ref('/myConfiremdEvents')
//const messagingRef = db.ref('/messages')
//const myConfirmedEventsRef = db.ref('myConfirmedEvents')
//const rejectedEventsRef = db.ref('/rejectedEvents')
const rejectedEventsCounterRef = db.ref('/counter/events/rejected/')


export const doListenEvents = async (sw) => {
    
    if(sw==='off') return eventsRef.off('value')
    let events = {}

    const dispatchEvents = (events) => {
        return dispatch({ type: FETCH_EVENTS, payload: events })
    }

    db.ref('/events').on('value', async snap=> {
        if(!snap.exists()) return dispatchEvents(events)
        return dispatchEvents(snap.val())
    })
    
}


export const doListenAdminEvents = async (state) => {
    
    if(state===false) {
        return eventsRef.off('value')
    }
    
    await eventsRef.on('value', async (eventsSnap)=>{
        const adminEventsArr = []
        let counter = 0
        // check snapshot existing if not return null
        const checkSnapExisting =  eventsSnap.exists()
        if(!checkSnapExisting) {
            const payload = null
            return dispatch({type: LISTEN_ADMIN_EVENTS, payload})
        }

        const events = await eventsSnap.val()
        const eventsArr= _.values(events)
        const eventsLength = eventsArr.length
        eventsArr.map(async event =>{
            const { userId } = event.data
            // query user data for user id
            const requester = await doFetchUser(userId)
     
            const adminEvent = event
            adminEvent.requester = requester
            adminEvent.id = event.data.id

            await adminEventsArr.push(adminEvent)
            counter++
            
            if(counter===eventsLength) {
                const payload = adminEventsArr
                return dispatch({type: LISTEN_ADMIN_EVENTS, payload})
            }
        })
    })
}


export const doSetConfirmedEvent = async (eventId, messageId, confirmedBy, newCanidate) => {

    const connectedEventSnap = await refConnectedEvent.child(eventId).once('value')
    const connectedEvent = await connectedEventSnap.val()
    const requesterId = await connectedEvent.requester.requesterId

    const requesterDataSnap = await db.ref(`/users/${requesterId}`).once('value')
    const requesterData = await requesterDataSnap.val()
    const confirmedEvent = connectedEvent
    const canidateId = connectedEvent.canidate.id
   
    if(typeof(newCanidate)!=='undefined'){
        confirmedEvent.admin.type = 'reconnected'
        const oldCanidate = {
            id: confirmedEvent.canidate.id,
            name: confirmedEvent.canidate.name,
        }
        confirmedEvent.admin.oldCanidate = oldCanidate
        confirmedEvent.canidate.id = newCanidate.id
        confirmedEvent.canidate.name = newCanidate.name
        confirmedEvent.requester = requesterData //new
       
      
    }
   
    confirmedEvent.confirmedBy = confirmedBy
    refConfirmedEvent.child(eventId).update(confirmedEvent)
    const canidateConfirmedEvent = {timeStamp: moment().format(), eventId: eventId, event: confirmedEvent.event, requester: requesterData}
    db.ref('/myConfirmedEvents').child(canidateId).child(eventId).set(canidateConfirmedEvent)
    refConnectedEvent.child(eventId).remove()
    doDeleteMessage(canidateId, messageId)
    db.ref('/canidates').child(connectedEvent.event.id).remove()
}

export const rejectConnectedEvent = async (message, event, userReason) => {
    let rejectedCounter = 0
    const updates = {}
    // remove message from canidate inbox
    updates[`/messages/${event.canidate.id}/inbox/${message.ids.messageId}`]=null
    // build rejectedEvent
    const rejectedEvent = {
        type: 'rejectedEvent',
        timeStamp: moment().format(),
        reason: userReason,
        event: event,   
        }
    // add rejected event to updates
    updates[`/rejectedEvents/${event.event.id}/`] = rejectedEvent
    
    // query rejectedEvents counter from user (canidate)
    const rejectedCounterSnap = await rejectedEventsCounterRef.child(event.canidate.id).once('value')
    if(rejectedCounterSnap.exists())
    rejectedCounter = await rejectedCounterSnap.val().value
    rejectedCounter++
    // update rejectedEvent counter for user / canidate
    updates[`/counter/events/rejected/${event.canidate.id}/value`] = rejectedCounter
   // do updates
    return db.ref().update(updates)
    
}

export const doCancelCanidateEvent = async (data) => {
    const {userId, messageId, eventId } = data
   
    db.ref('/messages/'+ userId + '/inbox').child(messageId).remove()
  
    const connectedEventSnap = await refConnectedEvent.child(eventId).once('value')
    await connectedEventSnap.val()
    db.ref('/connectedEvents').child(eventId).remove()
    //const test = db.ref('/events/' + userId ).child('data').set(connectedEvent.event)  
 
}

export const listenMyConfirmedEvents = async (userId) => {
  
   
    db.ref('/myConfirmedEvents').child(userId).on('value', confirmedEventsSnap => {
        if(!confirmedEventsSnap.exists()){
            const payload = {
                event: [],
                counter: 0,
            }
            return dispatch({type: 'MY_CONFIRMED_EVENTS', payload}) 
        }
        const confirmedEvents =  confirmedEventsSnap.val()
        const confirmedEventsArr = _.values(confirmedEvents)
    
        const payload = {
            event: confirmedEventsArr,
            counter: confirmedEventsArr.length
        }
        
        return dispatch({type: 'MY_CONFIRMED_EVENTS', payload: (payload)})
        
    })   
}

export const doUpdateEvent = (event) => {
    const eventId = event.id
    eventsRef.child(eventId).child('data').set(event)
}

export const doUpdateConnectedEvent = (event) => {
    const eventId = event.id
    refConnectedEvent.child(eventId).child('event').set(event)
}



// WEBPACK FOOTER //
// ./src/firebase/database/handleEvents.js